import { useTranslation } from 'react-i18next';

import type { Patient } from '../types/admin';
import styles from './AssignedAdminsStack.module.scss';

type AssignedAdmin = NonNullable<Patient['assigned_admins']>[number];

type AssignedAdminsStackProps = {
  readonly admins: readonly AssignedAdmin[];
  readonly max?: number;
};

/** Overlapping avatar stack for the admins assigned to a patient. */
export function AssignedAdminsStack({ admins, max = 3 }: AssignedAdminsStackProps) {
  const { t } = useTranslation();
  if (admins.length === 0) {
    return <span className={styles.empty}>{t('clients.noAssignedAdmins')}</span>;
  }
  const visible = admins.slice(0, max);
  const extra = admins.length - visible.length;
  return (
    <span className={styles.stack}>
      {visible.map((admin) => {
        const initials = `${admin.first_name[0] ?? ''}${admin.last_name[0] ?? ''}`;
        return (
          <span
            key={admin.id}
            className={styles.item}
            title={`${admin.first_name} ${admin.last_name}`}
          >
            {admin.avatar_url ? <img src={admin.avatar_url} alt="" /> : initials}
          </span>
        );
      })}
      {extra > 0 && <span className={styles.more}>+{extra}</span>}
    </span>
  );
}
